import { z } from 'zod';
import { itemSchema } from './item/item-dto';

/**
 * Loop items response DTO
 * Response from GET /api/v1/loop-visualization/:loopId/items endpoint.
 * Tree hierarchy is calculated client-side from item.parentId.
 */
export const loopItemsResponseSchema = z.object({
  items: z.array(itemSchema),
});

export type LoopItemsResponseDTO = z.infer<typeof loopItemsResponseSchema>;
